module.exports = __webpack_public_path__ + "img/weather01.a52608b0.png";